import React from "react";
import HomePage from "../pages/Home";
import NotFoundPage from "../pages/NotFoundPage";
import Login from "../pages/Auth/Login";
import Transporters from "../pages/Transporters";
import Parties from "../pages/Parties/Parties";
import PickLists from "../pages/PickLists/PickLists";
import CheckerPanel from "../pages/CheckerPanel/CheckerPanel";
import PendingInvoices from "../pages/PendingInvoices/PendingInvoices";
import PreDispatchReports from "../pages/PreDispatchReports/PreDispatchReports";
import DispatchReports from "../pages/DispatchReports/DispatchReports";
import DispatchReportPrint from "../pages/DispatchReports/Print";
import TransportForm from "../pages/Transporters/Form/Form";
import PartyForm from "../pages/Parties/Form/Form";
import PickListForm from "../pages/PickLists/Form/Form";
import PendingInvoiceForm from "../pages/PendingInvoices/Form/Form";
import DispatchSummary from "../pages/DispatchSummary/DispatchSummary";
import Profile from "../pages/Profile/Profile";
import Cities from "../pages/Cities";
import CityForm from "../pages/Cities/Form/Form";

const routes = [
  {
    path: "/",
    element: <HomePage />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/parties",
    element: <Parties />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/parties/add",
    element: <PartyForm />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/parties/edit/:id",
    element: <PartyForm />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/cities",
    element: <Cities />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/cities/add",
    element: <CityForm />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/cities/edit/:id",
    element: <CityForm />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/transporters",
    element: <Transporters />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/transporters/add",
    element: <TransportForm />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/transporters/edit/:id",
    element: <TransportForm />,
    isPrivate: true,
    layoutType: "Auth",
  },

  {
    path: "/pick-lists",
    element: <PickLists />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/pick-lists/add",
    element: <PickListForm />,
    isPrivate: true,
    layoutType: "Auth",
  },

  {
    path: "/pick-lists/edit/:id",
    element: <PickListForm />,
    isPrivate: true,
    layoutType: "Auth",
  },

  {
    path: "/checker-panel",
    element: <CheckerPanel />,
    isPrivate: true,
    layoutType: "Auth",
  },

  {
    path: "/pending-invoices",
    element: <PendingInvoices />,
    isPrivate: true,
    layoutType: "Auth",
  },

  {
    path: "/pending-invoices/edit/:id",
    element: <PendingInvoiceForm />,
    isPrivate: true,
    layoutType: "Auth",
  },

  {
    path: "/pre-dispatch-report",
    element: <PreDispatchReports />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/dispatch-report",
    element: <DispatchReports />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/dispatch-report/print/:id",
    element: <DispatchReportPrint />,
    isPrivate: false,
    layoutType: "Blank",
  },
  {
    path: "/login",
    element: <Login />,
    isPrivate: false,
    layoutType: "Blank",
  },
  {
    path: "/home",
    element: <HomePage />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/dispatch-summary",
    element: <DispatchSummary />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "/profile",
    element: <Profile />,
    isPrivate: true,
    layoutType: "Auth",
  },
  {
    path: "*",
    element: <NotFoundPage />,
    isPrivate: false,
    layoutType: "Blank",
  },
];

export default routes;
